import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import PiplLogo from '../../../Assets/pipl.svg';
import ApiService from '../../../Services/ApiService';
import styles from './AcceptInvitePage.module.less';

// In production the SPA is served under /accounts (see ApiService.getPrefix).
const getPrefix = () => (process.env.NODE_ENV !== 'development' ? '/accounts' : '');

// Public landing for the tokenized invite-accept email link. The token in the
// URL authenticates the move, so the user does not need to log in first (they
// often can't — their current org is disabled).
//
// The accept POST fires only on an explicit button click, NOT on page load:
// the invite is single-use, and email-security scanners / link previews that
// merely fetch the URL would otherwise consume it before the human clicks,
// leaving the real user with a dead ("expired") link.
const AcceptInvitePage = () => {
  const [submitting, setSubmitting] = useState(false);
  const token = new URLSearchParams(window.location.search).get('invite_token');

  const acceptInvite = () => {
    if (!token || submitting) {
      return;
    }

    setSubmitting(true);
    ApiService.acceptInviteByToken({ token })
      .then(() => window.location.assign(`${getPrefix()}/`))
      .catch(() => window.location.assign(`${getPrefix()}/invalid-token`));
  };

  return (
    <div className={styles.container}>
      <Helmet>
        <title>Accept invitation</title>
      </Helmet>
      <img src={PiplLogo} alt="Pipl" width="80" height="49" />
      <p className={styles.message} test-id="page-title">
        You have been invited to move to a new organization.
      </p>
      <button
        type="button"
        className={styles.button}
        onClick={acceptInvite}
        disabled={!token || submitting}
        test-id="accept-invite-button"
      >
        {submitting ? 'Accepting…' : 'Accept'}
      </button>
    </div>
  );
};

export default AcceptInvitePage;
